import abeagle from './abeagle';

if (window.HP.params.isEntry && window.HP.params.abeagle && Array.isArray(window.HP.params.abeagle)) {
  document.addEventListener('abeagleEventCambria', () => {
    const experiments = abeagle.getSessionExperiments();

    const abeagleTestsParams = [];
    if (experiments && Object.keys(experiments).length > 0) {
      Object.keys(experiments).forEach((name) => {
        const experimentId = experiments[name].id;
        const variantId = experiments[name].variant_id;
        const amazonParam = variantId ? `${experimentId}:${variantId}` : '0:0';
        abeagleTestsParams.push(amazonParam);
      });
    }
    const abeagleTestsParam = abeagleTestsParams.join(';');
    if (document.querySelector('body.entry') && abeagleTestsParams.length) {
      document.querySelectorAll('a[data-amazon-link]')
        .forEach((link) => {
          const href = decodeURIComponent(link.attributes.href.textContent);
          const parsedURL = new URL(href);
          const amazonParams = parsedURL.searchParams.get('ascsubtag');
          const amazonParamsWithAbeagleTest = amazonParams.replace(',0:0,', `,${abeagleTestsParam},`);
          parsedURL.searchParams.set('ascsubtag', amazonParamsWithAbeagleTest);
          parsedURL.search = new URLSearchParams(parsedURL.search).toString();
          let parsedURLWithAbeagle = parsedURL.toString();
          // bttn logic:
          const parts = parsedURLWithAbeagle.split('&ascsubtag');
          if (parts.length > 1) {
            parts[1] = encodeURIComponent(parts[1]);
          }
          parsedURLWithAbeagle = parts.join('%26ascsubtag');
          // eslint-disable-next-line no-param-reassign
          link.attributes.href.textContent = parsedURLWithAbeagle;
        });
    }
  }, { once: true });
}
